export const de = {
  // navbar
  home: "Startseite",
  menu: "Speisekarte",
  contact: "Kontakt",
  // home
  home_quote:
    'Seit Herbst 2013 bieten wir Dir, neben anderen interessanten Gerichten, das klassische peruanische Ceviche in unserem kleinen, entspannten Restaurant, gelegen zwischen Oranienplatz und Kottbusser Tor, im Herzen von Kreuzberg.\n Mit viel Liebe zum Detail nehmen wir Dich mit auf eine unverwechselbare Geschmacksreise durch die Vielfalt der peruanischen Küche.',
  // footer and contact
  timetable: "Öffnungszeiten",
  from_monday: "Von Montag bis Sonntag ab 18 Uhr.",
  sunday: "Sonntags geschlossen",
  follow_us: "Folge uns",
  // menu page
  menu_title: "SPEISEKARTE",
  starters: "VORSPEISEN",
  papas: "Kartoffeln mit Huancaina Sauce (Vegetarisch)",
  yuca: "Frittierter Maniok mit Huancaina Sauce oder Brava Sauce(Vegetarisch)",
  mejillones:
    "Miesmuscheln in Wein mit Karotte, eingelegten Zwiebeln und frischer Petersilie",
  garbanzos:
    "Kichererbsensalat mit Kürbis, Rote Bete und Honig-Orangen-Vinaigrette (Vegetarisch)",
  salmorejo: "Salmorejo vegan oder mit Mojama und hartgekochtem Ei",
  pallares: "Lima-Bohnen-Salat mit Orangenvinaigrette und frittiertem Rucola",
  ensalada: "Kürbissalat mit Rote Bete, Orange und Paranüssen",
  choros: " Miesmuscheln in Wein mit Petersillien-Schalotten und Ingwer",
  tiradito: "Fisch-Tiradito mit geräucherter Chili-'Leche de Tigre', Passionsfrucht, Pekannüssen und schwarzem Sesam",
  tartar: "Lachstatar mit 'Causa a la limeña' und milder Chili-Mayonnaise",
  quinoa: "Quinoasalat mit grünem Spargel, Minze und Mascarponecreme (vegetarisch)",
  tigre: "Tigermilch mit Fisch und Meeresfrüchten",
  beluga: "Beluga Linsensalat mit knackigem Lauch und Avocado-Creme (Vegetarisch)",

  endivias: "Chicorée-Rotkohl-Salat mit Kichererbsen, Feta-Käse, knusprigem Quinoa und Honig-Senf-Dressing (vegetarisch)",
  chicharron: "Knuspriges Chicharrón mit Süßkartoffel-Ingwer-Püree, Salsa und einer Reduktion aus Chicha Morada",

  hot_dishes: "WARMES ESSEN",
  locro: "Peruanischer Kürbiseintopf mit Kürbiskernen",
  queso: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 - mit Ziegenkäse",
  sopa: "Kreolische Miesmuschel- und Garnelensuppe mit Chili, Reis und knusprigem Mais",
  tataki: "Thunfisch-Tataki mit Wakame-Algensalat, Feigen-Soja-Reduktion und schwarzem Sesam",
  cevi_caliente:
    "Heisse Ceviche mit Kohl, Pilzen, gelber Chilischote und Bohnenpüree und Tahini",
  pulpo: "Gegrillter Oktopus mit Kürbispüree, Babykartoffeln, Feldsalat und Anticucho-Salsa",
  encebollado: "Thunfish mit angebratenen Zwiebeln, Rosmarin-Tomaten und frittierten Kartoffeln",
  atun: "Thunfischfilet mit Paprika-Minz-Sofrito und Kapern",
  pisto:" Andalusisches Ratatouille mit frittierten Artischocken und frischer Minze",

  cevi_vegano: "Veganes Ceviche (Gemüse und Früchte der Saison)",
  cevi_pescado: "Fisch-Ceviche",
  cevi_mixto: "Gemischtes Ceviche mit Fisch, Garnelen und Tintenfisch",
  cevi_pulpo: "Pulpo- und Fisch-Ceviche",
  cevi_nikkei: "Thunfisch-Ceviche mit Avocado und Nori Algen",

  desserts: "NACHTISCH",
  suspiro: "Lima-Seufzer (Toffee-Crème mit Merengue)",
  sueño: "Maracuya-Traum (Maracuya-Crème, Crumble und Merengue)",
  tarta: "Limettentorte mit Keks und geröstetem Baiser",

  drink_title: "GETRÄNKE",
  white_whine: "WEIßWEIN",
  red_whine: "ROTWEIN",
  beer: "BIER",
  long_drinks: "LONGDRINKS",
  soft_drinks: "SOFTDRINKS",
  coffee: "KAFFEE UND TEE",
  cocktails: "PISCO-COCKTAILS",

  bottle: "Flasche",
  juices: "Apfel / Ananas / Rhabarber / Saftschorle",
  water: "WASSER",
  gas: "Laut oder leise",
  tee: "Verschiedene Teesorten",

  no_alcohol: "Lammsbräu alkoholfrei",
  
  additives: "Zusatzstoffe",
  caffeine: "Koffein",
  eggwhite: "Eiweiß",
  colouring: "Farbstoff",
  sulphites: "Sulfite",

  // contact page
  data:"Daten",
  write_us: "Schreibe uns",
  contact_title: "KONTAKT",
  name: "Name",
  name_placeholder: "Dein Name",
  email: "E-Mail Adresse",
  email_placeholder: "Deine E-Mail Adresse",
  telephone: "Telefon",
  telephone_placeholder: "Deine Telefonnummer",
  message: "Nachricht",
  submit: "Senden",
  confirmation_Message: "Vielen Dank für deine Nachricht.",
};
